module.exports = __webpack_public_path__ + "img/doc_orange.df342de2.svg";